/* eslint-disable perfectionist/sort-objects */
export const liabilityValueMap: Record<string, number> = {
  '1-3x ARR': 1,
  '4-5x ARR': 2,
  '6-10x ARR': 3,
  '10-15x ARR': 4,
  '16-20x ARR': 5,
  '20x+ ARR': 6,
  'N/A': 0,
  'Unlimited': 7,
};
